import 'css-chunksrc/client/scenes/accountCreationConfirmation/form/planzoneForm/styles.scss';export default {
  "form": "_form_1wf3y_1",
  "group": "_group_1wf3y_8",
  "label": "_label_1wf3y_12",
  "row": "_row_1wf3y_18",
  "input": "_input_1wf3y_26",
  "invalidInput": "_invalidInput_1wf3y_41"
};